import { ASPEN_SITECODES, SPECIAL_SITECODES, ASPEN_SITECODE } from '../constants/sitecodes';
const checkSpecialSitecode = (sitecode: string) => {
  if (SPECIAL_SITECODES?.includes(sitecode)) return true;
  if (ASPEN_SITECODES?.includes(sitecode)) return ASPEN_SITECODE;
  return false;
};

export default checkSpecialSitecode;
